// components/DownloadExcelButton.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Dropdown } from "react-bootstrap";
import { FileExportIcon } from "@components/icons";
import { flattenTreeData } from "../utils/flattenTreeData";
import { exportListToExcel } from "../utils/exportToExcel";

type Props = {
  data: any[];
  title: string;
  renderMode?: "button" | "menu";
};
const DownloadExcelButton: React.FC<Props> = ({ data, title, renderMode = "button" }) => {
  const { t } = useTranslation();
  const handleClick = () => {
    const flatData = flattenTreeData(data, t);
    exportListToExcel(flatData, title);
  };

  if (renderMode === "menu") {
    return (
      <Dropdown.Item onClick={handleClick}>
        <FileExportIcon /> {t("download_tree_list")}
      </Dropdown.Item>
    );
  }

  return (
    <Button onClick={handleClick}>
      <FileExportIcon /> {t("download_tree_list")}
    </Button>
  );
};

export default DownloadExcelButton;
